import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Card, Grid, Table, Loader} from 'semantic-ui-react';
import {Actions} from '../../../common/actions';
import OrderElement from './orderElement';

class Detail extends Component {
  constructor(props) {
    super(props);
    this.state = { };
    this.handleAddClick = this.handleAddClick.bind(this);
  }

  handleAddClick() {
    this.props.addProviderOrderDetailElement();
  }

  renderOrders() {
    const {loading, detail = []} = this.props;

    if (loading) {
      return (
        <Table.Row>
          <Table.Cell colSpan='8' textAlign='center'>
            <Loader active inline='centered'/>
          </Table.Cell>
        </Table.Row>
      );
    }

    if (!detail.length) {
      return (
        <Table.Row>
          <Table.Cell colSpan='8' textAlign='center'>
          No se encontraron registros.
          </Table.Cell>
        </Table.Row>
      );
    }

    return detail.map((order, index) => {
      return (<OrderElement key={index} index={index} order={order} />);
    });
  }

  renderExtraColumns() {
    if (!this.props.isSpecial) {
      return null;
    }

    return (
      <React.Fragment>
        <Table.HeaderCell>Usuario</Table.HeaderCell>
        <Table.HeaderCell>Pedido Especial</Table.HeaderCell>
      </React.Fragment>
    );
  }

  render() {
    return (
      <Card raised fluid className='order-detail-section'>
        <Grid>
          <Grid.Row>
            <Grid.Column>
              <div className='tde-provider-order-detail-table'>
                <Table>
                  <Table.Header>
                    <Table.Row textAlign='center'>
                      <Table.HeaderCell>Código</Table.HeaderCell>
                      <Table.HeaderCell>Descripción</Table.HeaderCell>
                      <Table.HeaderCell>Solicitado</Table.HeaderCell>
                      <Table.HeaderCell>Confirmado</Table.HeaderCell>
                      <Table.HeaderCell>Procesado</Table.HeaderCell>
                      <Table.HeaderCell>Estado</Table.HeaderCell>
                      <Table.HeaderCell>Observación</Table.HeaderCell>
                      <Table.HeaderCell>Factura</Table.HeaderCell>
                      {this.renderExtraColumns()}
                      <Table.HeaderCell>Acciones</Table.HeaderCell>
                    </Table.Row>
                  </Table.Header>
                  <Table.Body>
                    {this.renderOrders()}
                  </Table.Body>
                </Table>
              </div>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row className='detail-extra-actions'>
            <Grid.Column>
              <a onClick={this.handleAddClick}><strong>Agregar Registro</strong></a>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Card>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'detail': state.providersOrdersManagementDetail.list,
    'isSpecial': state.providersOrdersManagementDetail.isSpecial,
    'loading': state.providersOrdersManagementDetail.loading,
  };
};

const {addProviderOrderDetailElement, withRouter} = Actions;

export default withRouter(connect(mapStateToProps, {
  addProviderOrderDetailElement,
})(Detail));
